<template>
    <div class="meeting">
        <img src="https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202010/4505cc0bd1344f80990327d82bc3eff4.png" alt="" style="cursor: pointer" @click="go1">
        <img src="https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202010/3aacc5f91eb5432d8df410a641841be0.png" alt="" style="margin-top: 30px;cursor: pointer" @click="go2">
        <img src="https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202010/c8d46688aff340409de1ca7ba5ba7088.png" alt="" style="margin-top: 30px;cursor: pointer" @click="go3">
        <img src="https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202010/0ea43bc9ebfb4c8cac0d76c76dbe824e.png" alt="" style="margin-top: 30px;cursor: pointer" @click="go4">
        <img src="https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202010/b977f13626a149cc81e48dab6455ac53.png" alt="" style="margin-top: 30px;cursor: pointer" @click="go5">
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "index",
        methods: {
            go1(){
                window.open("https://app3lxzcngw9132.h5.xiaoeknow.com/v1/course/alive/l_5f745ee9e4b0e95a89c2064f?type=2")
            },
            go2(){
                window.open("https://app3lxzcngw9132.h5.xiaoeknow.com/v1/course/alive/l_5f745eb2e4b0e95a89c20648?type=2")
            },
            go3(){
                window.open("https://app3lxzcngw9132.h5.xiaoeknow.com/v1/course/alive/l_5f745de7e4b0e95a89c20627?type=2")
            },
            go4(){
                window.open("https://app3lxzcngw9132.h5.xiaoeknow.com/v1/course/alive/l_5f745e7fe4b0e95a89c20641?type=2")
            },
            go5(){
                window.open("https://app3lxzcngw9132.h5.xiaoeknow.com/v1/course/alive/l_5f745e2ce4b0e95a89c20635?type=2")
            }
        }
    }
</script>

<style scoped lang="scss">
    .meeting{
        img{

        }
    }
</style>
